const translations = {
    agrianSource: 'From Agrian — not verified',
    cancelButton: 'Cancel',
    clearButton: 'Clear verification',
    closeButton: 'Close',
    confirmButton: 'Confirm formulation',
    contradiction:
        'The documents suggest different formulations ({{codes}}). Read each statement before choosing.',
    currentFormulation: 'Current formulation',
    documentError: 'This document could not be read.',
    evidenceHelper:
        'Quote the label sentence that states the formulation (at least 10 characters).',
    evidenceLabel: 'Evidence',
    loading: 'Reading the label and SDS — this can take a few seconds.',
    mentionsProduct: 'Names this product',
    mixingInstructions: 'Label mixing instructions',
    mixingNoteLabel: 'Label mixing note (optional)',
    noCode: 'No formulation code',
    noStatements: 'No formulation statements found in this document.',
    openDocument: 'Open document',
    readOnly: 'Read-only. Confirming a formulation requires the chemicals:verify permission.',
    retryButton: 'Retry',
    selfStatement: 'States its own formulation',
    sourceSeparator: ' — ',
    title: 'Review formulation',
    unknown: 'Unknown',
    unknownSource: 'Unknown formulation',
    verifiedOn: 'Verified {{date}}',
    verifiedSource: 'Verified'
};

export default translations;
